import React, { useState, useEffect } from 'react';
import { fetchSlaChamado, rotuloEstadoSla, corEstadoSla, horasParaTexto } from '../../../api/sla';
import './SlaIndicator.css';

function formatarDataHora(d) {
    if (!d) return '';
    const dt = new Date(d);
    return Number.isNaN(dt.getTime()) ? '' : dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function SlaIndicator({ satNum, compact = false }) {
    const [sla, setSla] = useState(null);
    const [carregado, setCarregado] = useState(false);

    useEffect(() => {
        let ativo = true;
        if (!satNum) return undefined;
        fetchSlaChamado(satNum).then((d) => { if (ativo) { setSla(d); setCarregado(true); } });
        return () => { ativo = false; };
    }, [satNum]);

    if (!carregado || !sla || !sla.tem_politica) return null;

    const cor = corEstadoSla(sla.estado);
    const pct = Math.min(100, Math.max(0, sla.percentual || 0));

    // Versão compacta: barra discreta no topo dos cards laterais.
    if (compact) {
        const resumo = sla.estado === 'resolvido'
            ? 'Concluído'
            : sla.estado === 'violado'
                ? 'Atrasado'
                : `${horasParaTexto(sla.restante_horas)} restantes`;
        return (
            <div className={`sla-compact sla-${cor}`} title={`SLA · ${rotuloEstadoSla(sla.estado)} · vence ${formatarDataHora(sla.vencimento)}`}>
                <div className="sla-compact-top">
                    <span className="sla-compact-label"><i className="fas fa-stopwatch me-1" />SLA</span>
                    <span className="sla-compact-estado">
                        {sla.pausado_agora && <i className="fas fa-pause me-1" title="Pausado" />}
                        {rotuloEstadoSla(sla.estado)} · {resumo}
                    </span>
                </div>
                {sla.estado !== 'resolvido' && (
                    <div className="sla-bar sla-bar-sm">
                        <div className="sla-bar-fill" style={{ width: `${Math.max(pct, 3)}%` }} />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="container-fluid px-3 sla-wrap">
            <div className={`card sla-card sla-${cor}`}>
                <div className="card-body py-2">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <span className="sla-titulo">
                            <i className="fas fa-stopwatch me-2" />SLA
                            <span className={`badge bg-${cor} ms-2`}>{rotuloEstadoSla(sla.estado)}</span>
                            {sla.pausado_agora && <span className="badge bg-secondary ms-1"><i className="fas fa-pause me-1" />Pausado</span>}
                        </span>
                        <span className="small text-muted">
                            {sla.estado === 'resolvido'
                                ? 'Chamado finalizado'
                                : sla.estado === 'violado'
                                    ? `Venceu em ${formatarDataHora(sla.vencimento)}`
                                    : <>Restam <strong>{horasParaTexto(sla.restante_horas)}</strong> · vence {formatarDataHora(sla.vencimento)}</>}
                        </span>
                    </div>
                    {sla.estado !== 'resolvido' && (
                        <div className="sla-bar mt-2">
                            <div className="sla-bar-fill" style={{ width: `${Math.max(pct, 3)}%` }} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SlaIndicator;
